import { ConnectApi } from '@js/plugins/connectApi';

export function logShowresultClick (className) {
	document.querySelectorAll('.' + className).forEach(el => el.addEventListener('click', () => {
		const link = el.dataset.pseudolink;
		const showresultId = parseInt(new URL(link, window.location.origin).searchParams.get('id'));
		ConnectApi('City', 'logShowresultClick', [showresultId]);
	}));
}
